import { ChangeDetectorRef, Component, DestroyRef, Inject, OnInit } from '@angular/core';
import { CoreFormComponent } from '@app/core/components/core-form/core-form.component';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { transition, trigger, useAnimation } from '@angular/animations';
import { HideAnimation, showAnimation } from '@app/shared/animations/transform-opacity';
import { SharedCoreFormService } from '@app/shared/services/shared-core-form.service';
import { GroupByPipe } from 'ngx-pipes';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ItemProps } from '@app/interfaces';
import { GovernmentalDamagedService } from '@app/governmental-damaged/governmental-damaged.service';
import { FormFooterComponent } from '@app/shared';
import { CustomFormFooterComponent } from '@app/shared/components/custom-form-footer/custom-form-footer.component';
import { SHARED_IMPORTS } from '@app/shared/shared.imports';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-governmental-damaged-form',
  templateUrl: './governmental-damaged-form.component.html',
  standalone: true,
  imports: [...SHARED_IMPORTS, FormFooterComponent, CustomFormFooterComponent],
  animations: [
    trigger('showHide', [
      transition('void => *', [
        useAnimation(showAnimation, {
          params: {
            timings: '200ms ease-in-out',
            transform: 'translateY(-10%)',
            opacity: '0'
          }
        })
      ]),
      transition('* => void', [
        useAnimation(HideAnimation, {
          params: {
            timings: '200ms 200ms ease-in-out',
            transform: 'translateY(-10%)',
            opacity: '0'
          }
        })
      ])
    ])
  ]
})
export class GovernmentalDamagedFormComponent extends CoreFormComponent implements OnInit {
  page_heading = false;
  stepperMode = true;
  arrayValid = false;
  isAlive = true;
  duplicationErrors: any = {};
  errorsRows: any[] = [];
  errorsMsgs: any[] = [];
  tabsErrors: any[] = [false, false, false];

  constructor(
    service: GovernmentalDamagedService,
    fb: FormBuilder,
    activatedRoute: ActivatedRoute,
    groupByPipe: GroupByPipe,
    sharedCoreFormService: SharedCoreFormService,
    // changeDetectorRef: ChangeDetectorRef,
    dialogRef: MatDialogRef<GovernmentalDamagedFormComponent>,
    private destroyRef: DestroyRef,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    super(
      service,
      fb,
      activatedRoute,
      groupByPipe,
      sharedCoreFormService,
      // changeDetectorRef,
      dialogRef,
      dialogData
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.service.loaded
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((loaded: boolean) => (this.loaded = loaded));

    this.service.shared.selectePermission$.subscribe(value => {
      if (value) {
        // console.log('value', value);

        this.form.patchValue(value);
        this.disableControls(['permission_number', 'units']);
        this.isEdit = true;
        this.updateAsPostExternal = true;
        this.itemId = this.form.get('permission_number').value;
      } else if (this.isEdit) {
        const Serial = this.form.get('permission_number').value;
        this.form.reset();
        this.form.get('permission_number').setValue(Serial);
        this.enableControls();
        this.itemId = null;
        this.isEdit = false;
        this.updateAsPostExternal = false;
      }
    });
    this.service.setModulePermissions();
    this.permissionsUpdateSubscription();
  }

  permissionsUpdateSubscription() {
    this.service.permissionsService.permissionsUpdated.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.service.setModulePermissions();
      this.unAuthRedirect();
    });
  }

  unAuthRedirect() {
    const permissionsKeys = this.activatedRoute.snapshot.data.permissionsKeys;
    if (permissionsKeys && permissionsKeys.length) {
      if (
        !permissionsKeys.every((permissionKey: { module?: string; key?: string }) => {
          return this.service.permissionsService.getPermissions(permissionKey.key);
        })
      ) {
        this.service.router.navigateByUrl('/401', { skipLocationChange: true });
      }
    }
  }

  disableControls(exception: string[]) {
    Object.keys(this.form.controls).forEach(key => {
      if (!exception.includes(key)) {
        this.form.controls[key].disable();
      }
    });
  }
  enableControls() {
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].enable();
    });
  }
  get lists() {
    return this._lists;
  }

  set lists(value: any) {
    this._lists = value;
  }

  refactorItem(item: any): any {
    super.refactorItem(item);
    if (item.photo) {
      this.previewImage = item.photo;
    }
    return item;
  }

  stepperRowAction(action: string, name: string, index: number) {
    // console.log(action, index);
    this.editId = null;
    if (action === 'edit') {
      // console.log(this.form.get('contacts').controls[index].value);

      this.editId = index;
      this.errorsRows = this.errorsRows.filter(d => d !== this.editId);
    }
    if (action === 'delete') {
      this.removeArrayItem(name, index);
    }
  }

  /**
   * Init form lists
   */
  initLists(): void {
    this.lists = [{ ['users/contractors']: 1 }];
  }
  checkDuplication(form: FormArray, lastItem: FormGroup) {
    let flag = true;

    this.duplicationErrors = {
      plate_number: false,
      qr_code: false,
      rfid: false
    };

    let index = 0;
    form.controls.forEach((item: FormGroup) => {
      if (!this.editId && this.editId !== 0 && form.controls.length !== 1 && index !== form.controls.length - 1) {
        if (item.controls['plate_number'].value === lastItem.controls['plate_number'].value) {
          this.duplicationErrors['plate_number'] = true;
          flag = false;
        } else if (item.controls['qr_code'].value === lastItem.controls['qr_code'].value) {
          this.duplicationErrors['qr_code'] = true;
          flag = false;
        } else if (item.controls['rfid'].value === lastItem.controls['rfid'].value && lastItem.controls['rfid'].value) {
          this.duplicationErrors['rfid'] = true;
          flag = false;
        }
      } else {
        if (this.editId && this.editId !== index) {
          if (item.controls['plate_number'].value === lastItem.controls['plate_number'].value) {
            this.duplicationErrors['plate_number'] = true;
            flag = false;
          } else if (item.controls['qr_code'].value === lastItem.controls['qr_code'].value) {
            this.duplicationErrors['qr_code'] = true;
            flag = false;
          } else if (
            item.controls['rfid'].value === lastItem.controls['rfid'].value &&
            lastItem.controls['rfid'].value
          ) {
            this.duplicationErrors['rfid'] = true;
            flag = false;
          }
        }
      }
      index++;
    });
    // Object.keys(form.controls).forEach(field => {
    //
    // })
    return flag;
  }
  checkDuplicationValidation(form: FormArray, lastItem: FormGroup) {
    let flag = true;
    let index = 0;
    form.controls.forEach((item: FormGroup) => {
      if (!this.editId && this.editId !== 0 && form.controls.length !== 1 && index !== form.controls.length - 1) {
        if (item.controls['plate_number'].value === lastItem.controls['plate_number'].value) {
          flag = false;
        }
      } else {
        if (this.editId && this.editId !== index) {
          if (item.controls['plate_number'].value === lastItem.controls['plate_number'].value) {
            flag = false;
          }
        }
      }
      index++;
    });
    // Object.keys(form.controls).forEach(field => {
    //
    // })
    if (flag) {
      return lastItem.controls['plate_number'].setErrors(null);
    } else {
      return lastItem.controls['plate_number'].setErrors({ duplicateNumber: true });
    }
  }
  addArrayItem(formArray: ItemProps[], name: string): void {
    this.isAlive = true;
    const items = this.form.get(name) as FormArray;

    let lastItem: FormGroup;
    if (!this.editId && this.editId != 0) {
      lastItem = items['controls'][items.controls.length - 1] as FormGroup;
    } else {
      lastItem = items['controls'][this.editId] as FormGroup;
    }

    Object.keys(lastItem.controls).forEach(field => {
      const control = lastItem.get(field); // {1}
      control.markAsTouched({ onlySelf: true }); // {2}
      control.markAsDirty({ onlySelf: true }); // {3}
    });

    if (this.checkDuplication(items, lastItem)) {
      if (lastItem.valid) {
        if (!this.editId && this.editId !== 0) {
          items.push(this.createArrayItem(formArray, name));
          this.arrayValid = true;
        }
        this.handleToggle(items, this.editId || items.controls.length - 2, lastItem);
        lastItem.controls['plate_number'].setErrors(null);
        this.editId = null;
        this.isAlive = false;
      }
    } else {
      if (this.duplicationErrors['plate_number'])
        lastItem.controls['plate_number'].setErrors({ dublicateRecord: true });
      else if (this.duplicationErrors['qr_code']) lastItem.controls['qr_code'].setErrors({ dublicateRecord: true });
      else lastItem.controls['rfid'].setErrors({ dublicateRecord: true });
    }
  }

  validateArrayGroup() {
    const contacts = (this.getFormControl('units') as any).controls;
    contacts.forEach((contact: FormGroup, index: number) => {
      if (index < contacts.length - 1) {
        this.markFormGroupTouched(contact);
      }
    });
  }
  getSelectedItem(key: string, val: any, testString: number) {
    if (val) {
      return val;
    }
  }

  removeArrayItem(name: string, index: number) {
    super.removeArrayItem(name, index);
    if ((this.form.get(name) as any).controls.length < 2) {
      this.arrayValid = false;
    }
  }

  handleToggle(array: FormArray, index: number, lastItem: FormGroup) {
    if (!lastItem.get('default_contact') || !lastItem.get('default_contact').value) return;
    array.controls.forEach((control, i) => {
      if (i !== index) {
        control.get('default_contact').setValue(false);
      }
    });
  }

  validateFormBeforeSumbit(saveAddNew?: any) {
    let valid = true;
    if (valid) {
      super.formSubmission(saveAddNew);
    }
  }

  /**
   * add server side validation errors into the errors array in each form control inside key serverError
   * @param errors => taken from fail response 422
   */
  ServerValidationErrors(errors: any) {
    if (!errors) {
      return;
    }
    let firstItem = '';
    Object.keys(errors).forEach((prop, index) => {
      if (index == 0) firstItem = prop;
      const formControl = this.form.get(prop);
      if (formControl) {
        // activate the error message
        formControl.setErrors({
          serverError: errors[prop]
        });
        formControl.markAsTouched();
      }
    });
    if (firstItem.includes('qr_code') || firstItem.includes('rfid') || firstItem.includes('plate_number')) {
      this.stepper.selectedIndex = 2;
      this.errorsRows = this.getErrorsRows(errors)['ids'];
      this.errorsMsgs = this.getErrorsRows(errors)['msgs'];
      this.tabsErrors[2] = true;
    } else {
      if (firstItem != 'contacts') {
        this.stepper.selectedIndex = 0;
        this.tabsErrors[0] = true;
      } else {
        this.stepper.selectedIndex = 1;
        this.tabsErrors[1] = true;
      }
    }
  }

  getErrorsRows(err: any) {
    let arr = Object.keys(err);
    let errorsRows: any[] = [];
    let msgs: string[][] = [];
    arr.forEach(e => {
      let number = +e.split('.')[1];
      errorsRows.push(number);
    });

    errorsRows.forEach((n, index) => {
      if (!msgs[n]) msgs[n] = [];
      msgs[n].push(err[arr[index]][0]);
    });

    let result: any = {};
    result['ids'] = [...errorsRows];
    result['msgs'] = [...msgs];
    // console.log("result", result);

    return result;
  }

  checkRowError(index: number) {
    if (this.errorsRows.length) {
      return this.errorsRows.includes(index);
    }
  }

  prepareFormAfterSubmit() {
    this.validateArrayGroup();
  }

  cancelFormSubmission() {
    if (this.form.dirty) {
      this.service.openActionDialog(
        this.service,
        'cancel',
        'common.confirmCancelForm.title',
        'common.confirmCancelForm.message',
        'common.confirmCancelForm.submitText',
        'common.confirmCancelForm.cancelText',
        null,
        'bg-danger'
      );
    } else {
      // this.service.navigateToList();
      // console.log(this.dialogRef);
      this.closeDialog();
    }
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control: any, index: number) => {
      control.markAsTouched();
      control.markAsDirty();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
